import type { CheckboxOnChangeArg, SelectOptions } from '@library/types/utils';
import { Checkbox } from '@library/components/inputs';
import { Listbox } from '@headlessui/react';
import { SELECT_ALL } from '@library/component-utils/filters';

export interface MultiSelectOptionsProps {
  options: SelectOptions;
  onChange: ({ id, checked }: CheckboxOnChangeArg) => void;
  savingDisabled?: boolean;
}

export const MultiSelectOptions = ({
  onChange,
  options,
  savingDisabled = false
}: MultiSelectOptionsProps) => {
  return options.map((option) => {
    const { key, name } = option;
    return (
      <Listbox.Option
        className="hover:bg-soFresh-140 text-soClean-100 w-full cursor-default select-none px-3 py-2 first-line:relative"
        key={key}
        value={option}
      >
        {({ selected }) => {
          return (
            <span>
              <Checkbox
                checked={selected}
                checkAll={option.key === SELECT_ALL}
                id={key}
                data-testid="multi-select-option"
                label={name}
                onCheckboxChange={onChange}
                disabled={savingDisabled}
              />
            </span>
          );
        }}
      </Listbox.Option>
    );
  });
};
